import React from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { Button } from 'primereact/button'
import { Card } from 'primereact/card'
import { Tag } from 'primereact/tag'
import { mockContracts, mockClients, mockProjects } from '../../../mocks'
import { contractStatusLabel, contractStatusSeverity } from '../utils/contractHelpers'
import { projectStatusLabel, projectStatusSeverity } from '../../Projects/utils/projectHelpers'

const ContractDetailPage: React.FC = () => {
  const { id } = useParams<{ id: string }>()
  const navigate = useNavigate()

  const contract = mockContracts.find((c) => c.id === id)
  if (!contract) {
    return (
      <div>
        <Button icon='pi pi-arrow-left' text label='Voltar' onClick={() => navigate(-1)} />
        <p>Contrato não encontrado.</p>
      </div>
    )
  }

  const client = mockClients.find((c) => c.id === contract.clientId)
  const projects = mockProjects.filter((p) => contract.projectIds.includes(p.id))

  const startDate = new Date(contract.startDate)
  const endDate = new Date(contract.endDate)
  const today = new Date()
  const daysLeft = Math.ceil((endDate.getTime() - today.getTime()) / (1000 * 60 * 60 * 24))

  return (
    <div style={{ maxWidth: 900 }}>
      <Button
        icon='pi pi-arrow-left'
        text
        label='Voltar para Contratos'
        onClick={() => navigate('/dashboard/contratos')}
        style={{ marginBottom: '1.5rem' }}
      />

      {/* Header */}
      <Card style={{ marginBottom: '1.5rem' }}>
        <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', flexWrap: 'wrap', gap: '1rem' }}>
          <div style={{ flex: 1 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '1rem' }}>
              <h2 style={{ margin: 0 }}>{contract.title}</h2>
              <Tag value={contractStatusLabel(contract.status)} severity={contractStatusSeverity(contract.status)} />
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: '1rem' }}>
              <div>
                <div style={{ fontSize: '0.8rem', color: 'var(--text-color-secondary)', marginBottom: '0.25rem' }}>Cliente</div>
                <div
                  style={{ fontWeight: 600, cursor: 'pointer', color: 'var(--primary-color)' }}
                  onClick={() => client && navigate(`/dashboard/clientes/${client.id}`)}
                >
                  {client?.name ?? '–'}
                </div>
              </div>
              <div>
                <div style={{ fontSize: '0.8rem', color: 'var(--text-color-secondary)', marginBottom: '0.25rem' }}>Início</div>
                <div style={{ fontWeight: 600 }}>{startDate.toLocaleDateString('pt-BR')}</div>
              </div>
              <div>
                <div style={{ fontSize: '0.8rem', color: 'var(--text-color-secondary)', marginBottom: '0.25rem' }}>Término</div>
                <div style={{ fontWeight: 600 }}>{endDate.toLocaleDateString('pt-BR')}</div>
              </div>
              <div>
                <div style={{ fontSize: '0.8rem', color: 'var(--text-color-secondary)', marginBottom: '0.25rem' }}>
                  {contract.status === 'active' ? 'Dias restantes' : 'Duração'}
                </div>
                <div style={{ fontWeight: 600, color: daysLeft < 30 && contract.status === 'active' ? '#f59e0b' : undefined }}>
                  {contract.status === 'active' ? `${daysLeft} dias` : '–'}
                </div>
              </div>
              <div>
                <div style={{ fontSize: '0.8rem', color: 'var(--text-color-secondary)', marginBottom: '0.25rem' }}>Mensalidade</div>
                <div style={{ fontWeight: 700, fontSize: '1.1rem', color: 'var(--primary-color)' }}>
                  R$ {contract.monthlyFee.toLocaleString('pt-BR')}
                </div>
              </div>
            </div>

            {contract.documentUrl && (
              <div style={{ marginTop: '1rem' }}>
                <a href={contract.documentUrl} target='_blank' rel='noreferrer'>
                  <Button icon='pi pi-file-pdf' label='Ver Documento' outlined size='small' />
                </a>
              </div>
            )}
          </div>
        </div>
      </Card>

      {/* Covered Projects */}
      <Card title='Aplicativos Cobertos'>
        {projects.length === 0 ? (
          <p style={{ color: 'var(--text-color-secondary)' }}>Nenhum aplicativo vinculado.</p>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
            {projects.map((p) => (
              <div
                key={p.id}
                style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0.75rem', borderRadius: 8, background: 'var(--surface-ground)', cursor: 'pointer' }}
                onClick={() => navigate(`/dashboard/aplicativos/${p.id}`)}
              >
                <div>
                  <div style={{ fontWeight: 600 }}>{p.name}</div>
                  <div style={{ fontSize: '0.82rem', color: 'var(--text-color-secondary)' }}>{p.hosting}</div>
                </div>
                <Tag value={projectStatusLabel(p.status)} severity={projectStatusSeverity(p.status)} />
              </div>
            ))}
          </div>
        )}
      </Card>
    </div>
  )
}

export default ContractDetailPage
